import React, { useContext } from 'react';
import { func } from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Button as AvonButton, useError } from '@avon/component-library';
import personalImg from './assets/personal.png';
import getDeviceType from '../../utils/getDeviceType';
import { setFirstLoginPage } from '../../utils/api/endpoints';
import HomeContext from '../../home/HomeContext';


const useStyles = makeStyles(theme => ({
  // desktop
  desktopLoadingPageContainer: {
    padding: '42px 42px 42px 56px',
    display: 'flex',
    justifyContent: 'space-between',
    fontFamily: 'Montserrat',
  },
  desktopContent: {
    flex: 1,
    paddingRight: 85,
  },
  desktopImage: {
    width: 409,
    height: 609,

    '& img': {
      width: '100%',
      height: '100%',
    },
  },
  desktopHeading: {
    fontFamily: 'Montserrat-Light',
    fontSize: '32px',
    lineHeight: '42px',
    color: '#546264',
  },
  desktopTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28px',
    color: '#546264',
    padding: '60px 0 30px',
  },
  stepItem: {
    paddingBottom: 48,
    paddingRight: 42,
    display: 'flex',

  },
  stepNo: {
    fontFamily: 'Montserrat-Light',
    fontSize: '44px',
    width: '38px',
    lineHeight: '44px',
    textAlign: 'center',
    color: theme.palette.colors.corePink,
    marginRight: 18,
  },
  stepLabel: {
    flex: 1,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#546264',
    minHeight: '44px',
    display: 'flex',
    alignItems: 'center',
  },
  desktopButton: {
    // width: 263,
    height: 58,
    // margin: '39px auto 0',

    // position: 'absolute',
    // width: 'calc(100% - 409px - 85px - 42px - 56px)',
    // bottom: '20px',

    position: 'fixed',
    width: 'calc(100% - 409px - 85px - 42px - 56px - 128px - 290px)',
    bottom: '80px',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > button': {
      width: 263,
    },
  },
  // tablet
  tabletLoadingPageContainer: {
    padding: '24px 24px 80px',
  },
  mobileLoadingPageContainer: {
    padding: '20px 24px 60px',
  },
  tabletHeading: {
    margin: '97px 0 60px',
    fontFamily: 'Montserrat-Light',
    fontSize: '42px',
    lineHeight: '54px',
    color: '#546264',
  },
  mobileHeading: {
    margin: '24px auto',
    fontFamily: 'Montserrat-Light',
    fontSize: '28px',
    lineHeight: '54px',
    color: '#546264',
    textAlign: 'center',
  },
  tabletContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  tabletImage: {
    width: 226,
    height: 320,
    marginLeft: 24,
    '& > img': {
      width: '100%',
      height: '100%',
    },
  },
  mobileImage: {
    height: 200,
    backgroundImage: `url(${personalImg})`,
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
    '& > img': {
      width: '100%',
      height: '100%',
    },
  },
  tabletTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28px',
    color: '#546264',
    padding: '0 0 30px',
  },
  tabletStepItem: {
    paddingRight: 0,

    '&:last-child': {
      paddingBottom: 42,
    },
  },
  tabletButton: {
    // width: 263,
    // height: 58,
    // margin: '0 auto',

    width: '100%',
    height: 58,
    position: 'fixed',
    left: 0,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > button': {
      width: 263,
    },
    bottom: 20,
    [theme.breakpoints.up('768')]: {
      bottom: 60,
    },
  },

}));

const LandingPage = ({ callApi, setMenuItem }) => {
  const deviceType = getDeviceType();
  const classes = useStyles();
  const { setError, cleanToastBanner } = useError();
  const [{ dashboard }] = useContext(HomeContext);
  const { landingPage } = JSON.parse(dashboard || sessionStorage.getItem('dashboard'));
  // const [sticky, setSticky] = useState(false);

  // const handleLandingPageScroll = (e) => {
  //   if (e.target.scrollTop < 100) {
  //     setSticky(true)
  //   } else {
  //     setSticky(false)
  //   }
  // }

  // useEffect(() => {
  // eslint-disable-next-line
  //   document.getElementById("bodyContent").addEventListener('scroll', handleLandingPageScroll, false);

  //   return () => {
  // eslint-disable-next-line
  //     document.getElementById("bodyContent").removeEventListener('scroll', handleLandingPageScroll);
  //   };
  // });

  const handleGetStartedClick = async () => {
    try {
      cleanToastBanner();
      await callApi(setFirstLoginPage());
      sessionStorage.setItem('currentPage', 'home');
      sessionStorage.setItem('firstLoginPage', false);
      setMenuItem('home');
    } catch ({ error }) {
      setError(error);
    }
  };

  const getLandingPgaeHtml = () => {
    if (deviceType === 'desktop') {
      return (
        <Box className={classes.desktopLoadingPageContainer}>
          <Box className={classes.desktopContent}>
            <Typography className={classes.desktopHeading}>
              {landingPage.header}
            </Typography>
            <Typography className={classes.desktopTitle}>
              {landingPage.title}
              :
              {' '}
            </Typography>
            {
              landingPage.list && landingPage.list.map((label, index) => (
                <Box className={classes.stepItem} key={`landingPage-step-item-${index}`}>
                  <Box className={classes.stepNo}>{index + 1}</Box>
                  <Box className={classes.stepLabel}>{label}</Box>
                </Box>
              ))
            }
          </Box>
          <Box className={classes.desktopImage}>
            <img src={personalImg} alt="personal" />
          </Box>
          <Box className={classes.desktopButton}>
            <AvonButton onClick={handleGetStartedClick}>{landingPage.getStarted}</AvonButton>
          </Box>
        </Box>
      );
    } // tablet/mobile
    return (
      <Box className={deviceType === 'mobile' ? classes.mobileLoadingPageContainer : classes.tabletLoadingPageContainer}>
        {
          deviceType === 'mobile' && (
            <Box className={classes.mobileImage}>
              {/* <img src={personalImg} alt="personal" /> */}
            </Box>
          )
        }
        <Typography className={deviceType === 'mobile' ? classes.mobileHeading : classes.tabletHeading}>
          {landingPage.header}
        </Typography>
        <Box className={classes.tabletContent}>
          <Box flex={1}>
            <Typography className={classes.tabletTitle}>
              {landingPage.title}
              :
              {' '}
            </Typography>
            {
                landingPage.list && landingPage.list.map((label, index) => (
                  <Box
                    className={`${classes.stepItem} ${classes.tabletStepItem}`}
                    key={`landingPage-step-item-${index}`}
                  >
                    <Box className={classes.stepNo}>{index + 1}</Box>
                    <Box className={classes.stepLabel}>{label}</Box>
                  </Box>
                ))
              }
          </Box>
          {
            deviceType === 'tablet' && (
              <Box className={classes.tabletImage}>
                <img src={personalImg} alt="personal" />
              </Box>
            )
          }
        </Box>
        <Box className={classes.tabletButton}>
          <AvonButton onClick={handleGetStartedClick}>{landingPage.getStarted}</AvonButton>
        </Box>
      </Box>
    );
  };
  return getLandingPgaeHtml();
};

LandingPage.propTypes = {
  callApi: func,
  setMenuItem: func,
};


export default LandingPage;
